import React, { useEffect, useMemo, useRef, useState } from "react";
import { PageHeader, Button, FormGroup, FormControl, ControlLabel, Checkbox } from "react-bootstrap";
import { View } from "react-native";
import styled from 'styled-components';
import { handleStripePayment, cancelStripePaymentSession } from "../utils/paymentHandler";
import ReservePageLayout from "../components/ReservePageLayout";
import "./reservations.css";

export default function ReadyNowCheckout(props) {
    const navState = (props.location && props.location.state) || {};
    const [fullName, setFullName] = useState(navState.fullName || "");
    const [companyName, setCompanyName] = useState(navState.companyName || "");
    const [email, setEmail] = useState(navState.email || "");
    const [phone, setPhone] = useState(navState.phone || "");
    const [qtyJobSight, setQtyJobSight] = useState(navState.qtyJobSight || 0);
    const [qtyJobSightPro, setQtyJobSightPro] = useState(navState.qtyJobSightPro || 0);
    
    // Billing Address
    const [billingAddress1, setBillingAddress1] = useState("");
    const [billingAddress2, setBillingAddress2] = useState("");
    const [billingCity, setBillingCity] = useState("");
    const [billingState, setBillingState] = useState("");
    const [billingZip, setBillingZip] = useState("");
    
    // Shipping Address
    const [shippingAddress1, setShippingAddress1] = useState("");
    const [shippingAddress2, setShippingAddress2] = useState("");
    const [shippingCity, setShippingCity] = useState("");
    const [shippingState, setShippingState] = useState("");
    const [shippingZip, setShippingZip] = useState("");
    
    // Checkbox for same as billing
    const [shippingSameAsBilling, setShippingSameAsBilling] = useState(true);
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [buttonText, setButtonText] = useState("Provide Credit Card and Pay Reservation");
    const [cancellable, setCancellable] = useState(false);
    const [stripePayment, setStripePayment] = useState(null);

    useEffect(() => {
        if(!navState || !navState.documentId) {
            const persistedDoc = JSON.parse(sessionStorage.getItem('documentId'));
            if(!persistedDoc) {
                props.history.replace('/reserve/ready');
            }
        }
    }, [navState, props.history]);

    // Auto-fill shipping address when checkbox is checked
    useEffect(() => {
        if (shippingSameAsBilling) {
            setShippingAddress1(billingAddress1);
            setShippingAddress2(billingAddress2);
            setShippingCity(billingCity);
            setShippingState(billingState);
            setShippingZip(billingZip);
        }
    }, [shippingSameAsBilling, billingAddress1, billingAddress2, billingCity, billingState, billingZip]);

    const numCameras = useMemo(() => (qtyJobSight) + (qtyJobSightPro), [qtyJobSight, qtyJobSightPro]);
    const amount = useMemo(() => 1, []); // Always $1 total
    const normalSubtotal = useMemo(() => (qtyJobSight * 300) + (qtyJobSightPro * 450), [qtyJobSight, qtyJobSightPro]);
    const promoDiscount = useMemo(() => Math.max(0, normalSubtotal - amount), [normalSubtotal, amount]);

    function renderSummaryAndCheckout() {
        return (
            <div className="reservation-width-100">
                <div className="reservation-card">
                    <div className="reservation-page-header-center">Order Summary</div>
                    <div className="reservation-summary-item">
                        <div>JobSight (2-cam)</div>
                        <div style={{display:"flex",gap:12}}>
                            <div>x{qtyJobSight}</div>
                            <div style={{color:"#6B7280"}}>@ $300/mo</div>
                            <div style={{width:80,textAlign:"right"}}>${qtyJobSight * 300}.00</div>
                        </div>
                    </div>
                    <div className="reservation-summary-item">
                        <div>JobSight PRO (4-cam)</div>
                        <div style={{display:"flex",gap:12}}>
                            <div>x{qtyJobSightPro}</div>
                            <div style={{color:"#6B7280"}}>@ $450/mo</div>
                            <div style={{width:80,textAlign:"right"}}>${qtyJobSightPro * 450}.00</div>
                        </div>
                    </div>
                    <div className="reservation-summary-subtotal">
                        <div className="text-gray-600">Subtotal</div>
                        <div style={{fontWeight:600}}>${normalSubtotal}.00</div>
                    </div>
                    <div className="reservation-summary-promo">
                        <div className="text-success">Show Promotion ($1 total)</div>
                        <div className="text-success" style={{fontWeight:600}}>- ${promoDiscount}.00</div>
                    </div>
                    <div className="reservation-summary-total-cameras">
                        <div>Total cameras</div>
                        <div>{numCameras}</div>
                    </div>
                    <div className="reservation-summary-amount-due">
                        <div>Amount due today</div>
                        <div>${amount}.00</div>
                    </div>
                    <div className="reservation-summary-promo-text">
                        Show promotion: $1 total for your first month. Our standard rates will not begin until one month after your camera(s) arrive.
                    </div>
                    
                    {/* Checkout Button */}
                    <div style={{borderTop:"1px solid #E5E7EB",marginTop:16,paddingTop:16}}>
                        <form onSubmit={handleSubmit}>
                            <Button
                                block
                                type="submit"
                                bsSize="large"
                                className={!isSubmitting && fullName!=="" && email!=="" && phone!=="" && billingAddress1!=="" && billingCity!=="" && billingState!=="" && billingZip!=="" && (shippingSameAsBilling || (shippingAddress1!=="" && shippingCity!=="" && shippingState!=="" && shippingZip!=="")) ? "reservation-submit-button-ready" : ""}
                                disabled={isSubmitting || fullName==="" || email==="" || phone==="" || billingAddress1==="" || billingCity==="" || billingState==="" || billingZip==="" || (!shippingSameAsBilling && (shippingAddress1==="" || shippingCity==="" || shippingState==="" || shippingZip===""))}
                            >
                                {buttonText}
                            </Button>
                        </form>
                        {/* <div style={{paddingTop:12,fontSize:12,color:"#6B7280",display:"flex",alignItems:"center",justifyContent:"center"}}>
                            <span style={{fontSize:14,marginRight:6}}>💳</span> You'll be asked by our team to tap your card on our secure reader.
                        </div> */}
                    </div>
                    
                    {/* Secure text */}
                    <div style={{paddingTop:16,fontSize:12,color:"#6B7280",textAlign:"center"}}>
                        <span style={{fontSize:14,marginRight:6}}>🔒</span> All transactions are secure and encrypted.
                    </div>
                </div>
            </div>
        );
    }

    function showError(msg) {
        // You may want to implement error display similar to Reservations.js
        console.error(msg);
        alert(msg);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);
        
        const customerData = {
            fullName: fullName,
            companyName: companyName,
            email: email,
            phone: phone,
            address: {
                line1: billingAddress1,
                line2: billingAddress2,
                city: billingCity,
                state: billingState,
                postal_code: billingZip,
                country: 'US'
            },
            shipping: {
                name: fullName,
                phone: phone,
                address: {
                    line1: shippingAddress1,
                    line2: shippingAddress2,
                    city: shippingCity,
                    state: shippingState,
                    postal_code: shippingZip,
                    country: 'US'
                }
            },
            metadata: {
                qtyJobSight: qtyJobSight,
                qtyJobSightPro: qtyJobSightPro,
                documentId: navState.documentId || JSON.parse(sessionStorage.getItem('documentId')) || ''
            },
        };

        await handleStripePayment({
            customerData,
            amount: amount,
            description: `Show Promotion Reservation: ${qtyJobSight} JobSight (2-cam) + ${qtyJobSightPro} JobSight PRO (4-cam) units`,
            onStatusChange: setButtonText,
            onError: (msg) => {
                setStripePayment(null); // Clear payment after error
                showError(msg);
            },
            onSuccess: (customerId) => {
                setCancellable(false);
                setStripePayment(null); // Clear payment after success
                // Store customerId in sessionStorage for access in success page
                if (customerId) {
                    sessionStorage.setItem('stripeCustomerId', JSON.stringify(customerId));
                }
                // Navigate to success page or show success message
                props.history.push('/reserve/ready/success');
            },
            onCancellable: setCancellable,
            onPaymentStarted: setStripePayment
        });
        
        setIsSubmitting(false);
    }

    async function cancelPayment(e) {
        if(stripePayment) {
            try {
                await cancelStripePaymentSession(stripePayment.id);
                setCancellable(false);
                setStripePayment(null);
                setIsSubmitting(false);
                setButtonText("Provide Credit Card and Pay Reservation");
                alert("Payment Cancelled");
            } catch(error) {
                showError(error.message);
            }
        }
    }

    return (
        <ReservePageLayout handleLogout={props.handleLogout}>
            <View>
                <div className="reservation-page-header">
                    <PageHeader>
                        Checkout
                    </PageHeader>
                </div>
                <div className="reservation-center-row">
                <div className="reservation-width-standard">
                    <div className="reservation-grid-2col">
                        {/* Left Column: Billing and Shipping */}
                        <div>
                            {/* Billing Address */}
                            <div className="reservation-card-margin-bottom">
                                <div className="reservation-page-header-center">Billing Address</div>
                                <View className="reservation-form-row">
                                    <View className="reservation-form-row">
                                        <FormGroup controlId="fullName" bsSize="large" className="reservation-form-group">
                                            <ControlLabel>Customer Name</ControlLabel>
                                            <FormControl value={fullName} onChange={e => setFullName(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                    <View className="reservation-form-row-spacing-24">
                                        <FormGroup controlId="companyName" bsSize="large" className="reservation-form-group">
                                            <ControlLabel>Company Name</ControlLabel>
                                            <FormControl value={companyName} onChange={e => setCompanyName(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                </View>
                                <View className="reservation-form-row">
                                    <View className="reservation-form-row">
                                        <FormGroup controlId="billingAddress1" bsSize="large" className="reservation-form-group">
                                            <ControlLabel>Address Line 1</ControlLabel>
                                            <FormControl value={billingAddress1} onChange={e => setBillingAddress1(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                </View>
                                <View style={{flex:1, flexDirection:"row"}}>
                                    <View style={{flex:1, flexDirection:"row"}}>
                                        <FormGroup controlId="billingAddress2" bsSize="large" style={{width:"100%"}}>
                                            <ControlLabel>Address Line 2 (optional)</ControlLabel>
                                            <FormControl value={billingAddress2} onChange={e => setBillingAddress2(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                </View>
                                <View style={{flex:1, flexDirection:"row"}}>
                                    <View style={{flex:1,flexDirection:"row"}}>
                                        <FormGroup controlId="billingCity" bsSize="large" style={{width:"100%"}}>
                                            <ControlLabel>City</ControlLabel>
                                            <FormControl value={billingCity} onChange={e => setBillingCity(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                    <View style={{flex:1, flexDirection:"row",paddingLeft:"24px"}}>
                                        <FormGroup controlId="billingState" bsSize="large" style={{width:"100%"}}>
                                            <ControlLabel>State</ControlLabel>
                                            <FormControl value={billingState} onChange={e => setBillingState(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                    <View style={{flex:1, flexDirection:"row",paddingLeft:"24px"}}>
                                        <FormGroup controlId="billingZip" bsSize="large" style={{width:"100%"}}>
                                            <ControlLabel>ZIP</ControlLabel>
                                            <FormControl value={billingZip} inputMode="numeric" onChange={e => setBillingZip(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                </View>
                                <View className="reservation-form-row">
                                    <FormGroup controlId="phone" bsSize="large" className="reservation-form-group">
                                        <ControlLabel>Phone Number</ControlLabel>
                                        <FormControl type="tel" value={phone} onChange={e => setPhone(e.target.value)} />
                                    </FormGroup>
                                </View>
                            </div>

                            {/* Shipping Address */}
                            <div className="reservation-card">
                                <div className="reservation-page-header-center">Shipping Address</div>
                                <View style={{paddingBottom:"16px"}}>
                                    <Checkbox 
                                        checked={shippingSameAsBilling} 
                                        onChange={e => setShippingSameAsBilling(!shippingSameAsBilling)}
                                    >
                                        <div style={{paddingLeft:"20px"}}>My shipping address is the same as my billing address</div>
                                    </Checkbox>
                                </View>
                                {!shippingSameAsBilling && (
                                    <>
                                        <View className="reservation-form-row">
                                            <View className="reservation-form-row">
                                                <FormGroup controlId="shippingAddress1" bsSize="large" className="reservation-form-group">
                                                    <ControlLabel>Address Line 1</ControlLabel>
                                                    <FormControl value={shippingAddress1} onChange={e => setShippingAddress1(e.target.value)} />
                                                </FormGroup>
                                            </View>
                                        </View>
                                        <View style={{flex:1, flexDirection:"row"}}>
                                            <View style={{flex:1, flexDirection:"row"}}>
                                                <FormGroup controlId="shippingAddress2" bsSize="large" style={{width:"100%"}}>
                                                    <ControlLabel>Address Line 2 (optional)</ControlLabel>
                                                    <FormControl value={shippingAddress2} onChange={e => setShippingAddress2(e.target.value)} />
                                                </FormGroup>
                                            </View>
                                        </View>
                                        <View style={{flex:1, flexDirection:"row"}}>
                                            <View style={{flex:1,flexDirection:"row"}}>
                                                <FormGroup controlId="shippingCity" bsSize="large" style={{width:"100%"}}>
                                                    <ControlLabel>City</ControlLabel>
                                                    <FormControl value={shippingCity} onChange={e => setShippingCity(e.target.value)} />
                                                </FormGroup>
                                            </View>
                                            <View style={{flex:1, flexDirection:"row",paddingLeft:"24px"}}>
                                                <FormGroup controlId="shippingState" bsSize="large" style={{width:"100%"}}>
                                                    <ControlLabel>State</ControlLabel>
                                                    <FormControl value={shippingState} onChange={e => setShippingState(e.target.value)} />
                                                </FormGroup>
                                            </View>
                                            <View style={{flex:1, flexDirection:"row",paddingLeft:"24px"}}>
                                                <FormGroup controlId="shippingZip" bsSize="large" style={{width:"100%"}}>
                                                    <ControlLabel>ZIP</ControlLabel>
                                                    <FormControl value={shippingZip} inputMode="numeric" onChange={e => setShippingZip(e.target.value)} />
                                                </FormGroup>
                                            </View>
                                        </View>
                                    </>
                                )}
                            </div>
                        </div>
                        
                        {/* Right Column: Email and Combined Summary/Checkout */}
                        <div>
                            {/* Email Card */}
                            <div className="reservation-card-margin-bottom">
                                <View className="reservation-form-row">
                                    <View className="reservation-form-row">
                                        <FormGroup controlId="email" bsSize="large" className="reservation-form-group">
                                            <ControlLabel>Email</ControlLabel>
                                            <FormControl type="email" value={email} onChange={e => setEmail(e.target.value)} />
                                        </FormGroup>
                                    </View>
                                </View>
                                <div className="reservation-help-text">We'll send your receipt and updates to this email.</div>
                            </div>

                            {/* Order Summary and Checkout Button (Combined) */}
                            {renderSummaryAndCheckout()}
                        </div>
                    </div>
                    {cancellable && (
                        <View style={{paddingTop:"10px",flex:1,flexDirection:"row",justifyContent:"center"}}>
                            <View style={{width:"200px"}}>
                                <Button
                                    block
                                    bsSize="large"
                                    bsStyle="danger"
                                    disabled={!cancellable}
                                    onClick={(e) => cancelPayment(e)}
                                >
                                    Cancel Transaction
                                </Button>
                            </View>
                        </View>
                    )}
                </div>
            </div>
            </View>
        </ReservePageLayout>
    );
}


